import { z } from 'zod';

export const PreferenceProfileResponseMetaDataAuditTrack = z.nullable(
  z.object({
    sourceSystemTransactionID: z.string().nullable(),
    serviceTransactionID: z.string().nullable(),
    sourceApplicationName: z.string().nullable(),
    sourceUserName: z.string().nullable(),
    sourceSystemTimeStamp: z.string().nullable(),
    exceptionNotificationEmailAddress: z.string().nullable(),
  })
);

export const PreferenceProfileResponseMetaData = z.nullable(
  z.object({
    auditTrack: PreferenceProfileResponseMetaDataAuditTrack,
  })
);

export const PreferenceProfileResponseCustomerData = z.nullable(
  z.object({
    contactProfileId: z.string().nullable(),
    customerId: z.string().nullable(),
  })
);

export const PreferenceProfileResponseData = z.nullable(
  z.object({
    metaData: PreferenceProfileResponseMetaData,
    data: PreferenceProfileResponseCustomerData,
  })
);

export type PreferenceProfileResponseData = z.infer<
  typeof PreferenceProfileResponseData
>;
